export default __webpack_public_path__ + "static/media/flower_flor_2.c3647dbf.png";